<template>
  <div class="search-result">
    <!-- 搜索头部 -->
    <div class="search-head">
      <div class="back" @click="backPage('搜索结果-返回')"></div>
      <div class="search-input" @click="backPage('搜索结果-搜索框')">
        <div class="search-icon"></div>
        <input type="text" v-model="$route.params.seatchHot" class="search-content"  readonly unselectable="on" >
      </div>
    </div>
    <div v-if="!noStatus" class="no-nolist">
      <!-- tab切换 -->
      <ul class="head-ul">
        <li
            v-for="item in activeList"
            :key="item.id"
            :class="item.id === searchParams.queryCriteria ? 'ul-active' : ''"
            @click="handleSelect(item.id,item.title)"
        >
          {{ item.title }}
          <img
              v-if="item.id === searchParams.queryCriteria"
              alt=""
              src="@/assets/images/babyFeeding/monthLine.png"
          />
        </li>
      </ul>
      <!-- 搜索结果列表数据 -->
      <van-list
        id="vanList"
        v-model="loadingParams.loading"
        :error.sync="loadingParams.error"
        :finished="loadingParams.finished"
        :finished-text="loadingParams.bottomText"
        error-text="请求失败，点击重新加载"
        :immediate-check="false"
        @load="getArticleList()"
      >
        <waterfallComponents
            :ref="'waterfall' + searchParams.queryCriteria"
            :leftRightGap="6"
            :pageMargin="12"
            :upDownGap="6"
            class="water-fall"
            @clickHander="clickHander"
            @styleEnd="styleEnd"
        >
          <template slot-scope="props">
            <div :data="JSON.stringify(props.data)" class="info">
              <div
                  v-lazy:background-image="props.data.contentImage"
                  class="info-img"
                  style="height: 230px;"
              ></div>
              <div class="bottom-content">
                <div class="item-title">{{ props.data.title }}</div>
                <div class="user-info">
                  <div class="user-message">
                    <img :src="props.data.userHeadImage" alt="" />
                    <div class="user-name">{{ props.data.userName  }}</div>
                  </div>
                  <div class="user-like" @click.stop="addLike(props.data)">
                    <img
                      :src="props.data.likeStatus === 1 ? liked : noLike"
                      alt=""
                    />
                    <div class="like-number">{{ fomatterNum(props.data.likeNum, false) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </waterfallComponents>
      </van-list>
    </div>
    <div v-if="noStatus" class="nolist">
      <div class="no-content">
        <img alt="" src="../../../assets/images/community/no-search.png">
        <p>无搜索结果，换个关键词试试</p>
      </div>
    </div>
  </div>
</template>

<script>
import API from "../../../utils/axiosApi/communityApi";
import waterfallComponents from "@/components/contents/waterfallComponents.vue"; //瀑布流
import {Debounce,isUserLogin,globalGoLogin,getUserInfo,fomatterNum,initClassTop, setClassTop} from '@/assets/js/common.js';
import { xmhh5CommunityClick_fn, BuiedPointClick_Fn } from "@/assets/js/BuriedPointEvent";
export default {
  components: { waterfallComponents },
  name:"grassResult",
  data() {
    return {
      activeList: [],
      showEmpty: false,
      dataShow: false,
      loadingParams: {
        loading: false,
        finished: false,
        bottomText: "",
        error: false,
      },
      searchParams: {
        queryCriteria:sessionStorage.getItem("tabIndex") ? JSON.parse(sessionStorage.getItem("tabIndex")) :  0,
        content: this.$route.params.seatchHot,
        pageNum: 1,
        pageSize: 10,
        crmId: getUserInfo(),
      },
      noLike: require("@/assets/images/community/like.png"),
      liked: require("@/assets/images/community/liked.png"),
      noStatus: false, //空状态
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    fomatterNum,
    // 请求搜索结果
    getArticleList: Debounce(function () {
      // this.loadingParams.loading = true;
      API.searchResultData({}, this.searchParams, (res) => {
        console.log(346711, res, res.data);
        if (res.code == 200) {
          const {total, data} = res.data;
          if (this.searchParams.pageNum == 1) {
            this.noStatus = data.length > 0 ? false : true
            if (data.length > 0) {
              this.activeList = [
                {title: "全部", id: 0},
                {title: "最新", id: 1},
                {title: "最热", id: 2},
              ]
            } else {
              this.activeList = []
            }
          }
          let id = this.searchParams.queryCriteria;
          if (this.searchParams.pageNum > 1) {
            this.$refs["waterfall" + id].initData("push", data);
          } else {
            this.$refs["waterfall" + id].initData("init", data);
          }
          this.$nextTick(() => {
            if (
                this.searchParams.pageNum * this.searchParams.pageSize >=
                total
            ) {
              this.loadingParams.finished = true;
              this.loadingParams.bottomText = "暂时没有更多内容啦~";
            } else {
              this.searchParams.pageNum++;
              this.loadingParams.loading = false;
            }
          });
        } else {
          this.$toast("网络异常");
          this.loadingParams.loading = false;
          this.loadingParams.error = true;
        }
        console.log(11111, res);
      });
    }),
    handleSelect: Debounce(function (value, type) {
      xmhh5CommunityClick_fn("xmhh5CommunityClick", {
        xmhh5_Community_Search_Click: type,
      })
      this.$refs["waterfall" + this.searchParams.queryCriteria].resetDefaultData();
      // document.getElementById("vanList").style.marginTop = "110px"
      this.searchParams.pageNum = 1
      this.loadingParams.finished = false;
      this.searchParams.queryCriteria = value;
      sessionStorage.setItem("tabIndex", value)
      this.getArticleList();
    }),
    // 跳转至详情页
    clickHander: Debounce(function (item) {
      this.$router.push({path: "/communityDetail/" + item.id})
    }),
    styleEnd() {
      this.loadingParams.loading = false;
      console.log(this.loadingParams.loading, 'styleEndloading')
    },
    addLike: Debounce(function (item) {
      console.log(33333, item)
      if (isUserLogin()) {
        globalGoLogin()
      } else {
        const params = {
          contentId: item.id,
          crmId: getUserInfo(),
          type: 2,
          state: item.likeStatus === 1 ? false : true
        }
        API.searchLike({}, params, (res) => {
          if (res.code == 200) {
            item.likeStatus = res.data.likeState ? 1 : 0
            if (item.likeStatus === 1) {
              item.likeNum = item.likeNum + 1
            } else {
              item.likeNum = item.likeNum - 1
            }
            console.log(11111, item.likeStatus)
          }
        })
      }

    }),
    backPage: Debounce(function (value) {
      this.searchParams.content = ""
      sessionStorage.removeItem("tabIndex")
      this.$store.commit('removeIncludes')
      if (window.history.length > 1) {
        this.$router.back(-1);
        setTimeout(()=>{
          $("input").focus()
        },500)
      } else {
        this.$router.push({ path: "/grassSearch/" + "搜索"});
        setTimeout(()=>{
          $("input").focus()
        },500)
      }
      xmhh5CommunityClick_fn("xmhh5CommunityClick", {
        xmhh5_Community_Search_Click: value,
      })
    })
  },
  activated() {
    setClassTop('community_Index')

  },
  beforeRouteLeave(to, from, next) {
    initClassTop('community_Index')
    next();
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.$store.commit("changeIncludes", [ "grassResult"]);
      BuiedPointClick_Fn("xmhh5CommunityallPageView", {
      xmhh5_Community_Page_Name: "搜索结果页"
    })
    this.getArticleList();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    window.onscroll = function () {
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    if (scrollTop < 0) {
      document.querySelector('.search-head').style.position = 'absolute'
      document.querySelector('.head-ul').style.position = 'absolute'
    } else {
      document.querySelector('.search-head').style.position = 'fixed'
      document.querySelector('.head-ul').style.position = 'fixed'
    }
  }
  },
};
</script>
<style lang="less" scoped>
// @import url(); 引入公共css类
.search-head {
  padding: 12px 12px 0 4px;
  display: flex;
  background-color: #F9F9F9;
    position: fixed;
    top: 0;
    z-index: 999;
    width: 95%;

  .back {
    width: 32px;
    height: 32px;
    background-image: url(../../../assets/images/community/back.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
  }

  .search-input {
    width: 319px;
    height: 30px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 16px;
    border: 1px solid #f3a0d7;
    margin-left: 8px;
    display: flex;
    align-items: center;

    .search-icon {
      width: 14px;
      height: 14px;
      background-image: url(../../../assets/images/babyFeeding/search.png);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center center;
      margin-left: 10px;
      margin-right: 2px;
    }

    .search-content {
      width: 280px;
      height: 30px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
      overflow: hidden;
      border: 0;
      display: block;
      background-color: transparent;
      // margin-top: -1px;
    }
  }
}

.search-result {
  height: 100vh;
  background: #F9F9F9;
}

.head-ul {
  display: flex;
  width: 363px;
  padding: 16px 0 16px 12px;
  background-color: #F9F9F9;
  position: fixed;
  top: 44px;
  z-index: 999;

  li {
    height: 25px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #666666;
    display: flex;
    // line-height: 25px;
    position: relative;
    margin-right: 24px;
    display: flex;
    align-items: flex-end;

    img {
      width: 10px;
      position: absolute;
      bottom: -2px;
      right: -10px;
    }
  }

  .ul-active {
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    display: flex;
    align-items: flex-end;
  }
}

/deep/ .van-list {
  background-color: #F9F9F9;
}

.no-nolist {
  padding-top: 103px;
  // height: 100%;
  background-color: #f9f9f9;
}

.water-fall {
  background-color: #F9F9F9;
}
/deep/ .water-fall .water-fall-item {
  border-radius: 6px;
  padding-bottom: 0px;
  overflow: hidden;

  .info-img {
    border-radius: 6px 6px 0px 0px;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .bottom-content{
   padding: 8px;
  }
  .item-title{
    height: 40px;
    font-size: 14px;
    font-weight: 500;
    color: #333333;
    line-height: 20px;
    word-break: break-all;
    text-overflow: -o-ellipsis-lastline;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .user-info {
    display: flex;
    justify-content: space-between;
    margin-top: 14px;

    .user-message {
      display: flex;
      align-items: center;

      img {
        width: 15px;
        height: 16px;
        border-radius: 50%;
        margin-right: 2px;
      }
    }
    .user-message {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      .user-name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .user-message,
    .user-like {
      display: flex;
      align-items: center;

      img {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        margin-right: 2px;
      }

      .like-number {
        font-size: 12px;
        font-weight: 400;
        color: #999999;
        height: 16px;
        line-height: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
      }
    }
  }
}

.nolist {
  display: flex;
  align-items: center;
  justify-content: center;

  .no-content {
    img {
      width: 90px;
      height: 90px;
      margin: 155px auto 16px;
      display: block;
    }
    p{
      // width: 182px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
    }
  }
}

/deep/ .van-list__loading {
  background: #F9F9F9;
  // padding-top: 20px;
}

/deep/ .van-list__finished-text {
  background: #F9F9F9;
}
</style>
